<script setup>
/**
 * Este componente gestiona el enlace que abre el modal remoto con el contenido
 * que devuelve el servidor. Utilizamos ModalRemotoLayout que utiliza el
 * modal estandar de Bootstrap.
 *
 * Básicamente se encarga de gestionar el show y hide del modal de bootstrap y los eventos
 * eventos del modal
 */
/* global $ */
import { ref, useTemplateRef, watch } from 'vue';

import ModalRemotoLayout from './ModalRemotoLayout.vue';

const props = defineProps({
  // Para controlar si se hace visible o no
  modelValue: { type: Boolean, default: false },
  modalConfig: {
    type: Object,
    default: undefined,
  },
});

const emits = defineEmits(['update:modelValue']);
const modal = useTemplateRef('modal');
const $modal = ref(null);
const showModal = ref(props.modelValue);
const showCancelado = ref(false);

function controlEventosModalBootstrap() {
  $modal.value.on('shown.bs.modal', (e) => {
    // TODO: Muy mejorable esta búsqueda
    $(e.currentTarget).find('input:first-child').trigger('focus');
  });
  $modal.value.on('hidden.bs.modal', () => {
    // Limpiamos el contenido porque si deja elementos en el modal oculto con algún id,
    // habrá interferencias entre modales. (Edición de entrevistas)
    showModal.value = false;
    emits('update:modelValue', false);
  });
}

function showModalBootstrap() {
  if (showCancelado.value) {
    showCancelado.value = false;
    showModal.value = false;
    return;
  }

  $modal.value = $(modal.value.$el);
  if (props.modalConfig) {
    $modal.value.modal(props.modalConfig);
  }
  controlEventosModalBootstrap();
  $modal.value.modal('show');
}

function hideModalBootstrap() {
  $modal.value?.modal('hide');
}

function layoutCargado() {
  showModalBootstrap();
}

watch(() => props.modelValue, (value) => {
  // Si es true, mostraremos el modal cuando se haya montado el layout en layoutCargado
  showModal.value = value;
  if (!value) {
    hideModalBootstrap();
  }
});

defineExpose(
  {
    show() {
      showModal.value = true;
      emits('update:modelValue', true);
    },
  });
</script>

<template>
  <ModalRemotoLayout
    v-if="showModal"
    ref="modal"
    @cancelado="showCancelado = true"
    @vue:mounted="layoutCargado"
  ></ModalRemotoLayout>
</template>
